<template>
  <div class="fill-height">
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="#ff64ad">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-layout wrap>
      <v-flex>
        <section>
          <v-card 
            flat 
            style="border: 1px solid #E0E0E0;">
            <v-card-text>
              <v-row>
                <v-col cols="12" md="8" class="d-flex align-center">
                  <!-- DETAIL -->
                  <div class="mr-3" v-if="selected.row.length === 1">

                    <v-btn
                      :to="`/user/request/${selected.row[0].id}`"
                      elevation="0"
                      style="background: #e0e0e0;"
                      class="body-2 text-capitalize font-weight-bold d-flex align-center text-second">
                      <v-icon size="18">mdi-information-outline</v-icon>

                      <span class="ml-1">
                        Detail
                      </span>
                    </v-btn>
                  </div>
                </v-col>

                <v-col cols="12" md="4" class="d-flex align-center justify-end">
                  <v-text-field 
                    class="mr-3"
                    dense
                    single-line
                    hide-details
                    color="#ff64ad"
                    placeholder="Cari . . ."
                    append-icon="mdi-magnify"
                    clearable
                    v-model="search"
                    v-uppercase
                    @click:clear="search = ''; fetch();"
                    v-on:keyup.enter="fetch()">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-card-text>

            <v-data-table
              v-model="selected.row"
              ref="table-grid"
              class="table-grid"
              :height="`calc(100vh - ${pagination.total_data > 0 ? '330px' : '258px'})`"
              :show-select="true"
              :single-select="true"
              :loading="process.load"
              loading-text="Sedang memuat data . . ."
              loader-height="5"
              no-results-text="Belum ada data"
              :options.sync="options"
              :headers="headers"
              :items="list.data"
              :items-per-page="100"
              item-key="id"
              @click:row="rowClick"
              @toggle-select-all="handleToggleAll($event)"
              hide-default-footer>
              <template v-slot:[`item.index`]="{ index }">
                {{ lastIndex + index }}
              </template>

              <v-progress-linear 
                v-show="process.load" 
                slot="progress" 
                color="white" 
                indeterminate>
              </v-progress-linear>
            </v-data-table>

            <pagination v-if="pagination.total_data > 0"
              @changePage="fetch($event)" 
              @reloadPage="fetch($event)" 
              :model="pagination"/>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        dialog: {
          snackbar: false,
          fullscreen: false
        },
        search: '',
        selected: {
          row: []
        },
        options: {},
        headers: [],
        detail: {},
        list: {
          data: []
        },
        limit: 20,
        pagination: {},
        lastIndex: 0,
        process: {
          load: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    watch: {
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          this.fetch(pagination)
        },
        deep: true
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },
      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: this.options.sortBy.length < 1 ? 'id' : this.options.sortBy[0],
          order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search
        }

        this.selected.row = []

        await get('user/user_request_update/list', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.code === 200) {
            this.headers = [
              {
                text: '#No',
                width: '75px',
                value: 'index',
                sortable: false,
                freeze: true,
                hide: false,
                align: 'center'
              },
              {
                text: 'Nama Lengkap',
                width: '200px',
                value: 'uru_fullname',
                freeze: false,
                hide: false
              },
              {
                text: 'NIK',
                width: '200px',
                value: 'uru_nik',
                freeze: false,
                hide: false
              },
              {
                text: 'KK',
                width: '200px',
                value: 'uru_kk',
                freeze: false,
                hide: false
              },
              {
                text: 'Email',
                width: '100px',
                value: 'uru_email',
                freeze: false,
                hide: false
              },
              {
                text: 'Telepon',
                width: '100px',
                value: 'uru_phone',
                freeze: false,
                hide: false
              }
            ]
            
            this.list.data = res.data
            this.pagination = res.pagination

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1
          }
        })
      }
    }
  }
</script>